import { useState } from 'react';
import { yachts, yachtCategories } from '../../../mocks/yachts';

interface ProductsProps {
  onProductSelect: (product: any) => void;
}

export default function Products({ onProductSelect }: ProductsProps) {
  const [selectedCategory, setSelectedCategory] = useState("Todos");
  const [visibleCount, setVisibleCount] = useState(6);

  const filteredYachts = selectedCategory === "Todos" 
    ? yachts 
    : yachts.filter(yacht => yacht.category === selectedCategory);

  const displayedYachts = filteredYachts.slice(0, visibleCount);

  const loadMore = () => {
    setVisibleCount(prev => prev + 6);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-slate-800 to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-5xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent mb-6 font-playfair">
            Flota de Élite
          </h3>
          <div className="w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-400 mx-auto mb-6 rounded-full"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Embarcaciones de última generación para aventuras épicas en las cristalinas aguas de Los Cabos
          </p>
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap justify-center gap-4 mb-16">
          {yachtCategories.map((category) => (
            <button
              key={category}
              onClick={() => {
                setSelectedCategory(category);
                setVisibleCount(6);
              }}
              className={`px-8 py-4 rounded-full font-medium transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer ${
                selectedCategory === category
                  ? 'bg-gradient-to-r from-cyan-500 to-blue-600 text-white shadow-lg shadow-cyan-500/25'
                  : 'bg-slate-800/50 backdrop-blur-xl text-gray-300 hover:text-white border border-cyan-500/20 hover:border-cyan-400/40'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12" data-product-shop="true">
          {displayedYachts.map((yacht) => (
            <div
              key={yacht.id}
              className="group bg-slate-800/50 backdrop-blur-xl rounded-2xl border border-cyan-500/20 overflow-hidden hover:border-cyan-400/50 transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-cyan-500/20"
            >
              <div className="relative h-64 overflow-hidden cursor-pointer">
                <img
                  alt={yacht.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  src={yacht.image}
                />
                <div className="absolute top-4 right-4 bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-4 py-2 rounded-full font-bold text-sm">
                  {yacht.category}
                </div>
              </div>
              
              <div className="p-6">
                <h4 className="text-2xl font-bold text-white mb-3 group-hover:text-cyan-400 transition-colors cursor-pointer">
                  {yacht.name}
                </h4>
                <p className="text-gray-400 mb-4 line-clamp-2">
                  {yacht.description}
                </p>
                
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-2 text-gray-300">
                    <i className="ri-group-line text-cyan-400"></i>
                    <span className="text-sm">Hasta {yacht.capacity} personas</span>
                  </div>
                </div>
                
                <div className="flex items-baseline space-x-2 mb-4">
                  <span className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
                    ${yacht.price.toLocaleString()}
                  </span>
                  <span className="text-gray-400 text-sm">MXN</span>
                </div>
                
                <p className="text-gray-400 text-xs mb-4">
                  <i className="ri-time-line mr-1"></i>Paquete de {yacht.hours} horas
                </p>
                
                <div className="space-y-2">
                  <button
                    onClick={() => onProductSelect(yacht)}
                    className="w-full bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500/50 text-white py-3 rounded-xl font-bold hover:from-cyan-500/30 hover:to-blue-500/30 transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-information-line mr-2"></i>Ver Detalles
                  </button>
                  <button className="w-full bg-gradient-to-r from-cyan-500 to-blue-600 text-white py-3 rounded-xl font-bold hover:from-cyan-400 hover:to-blue-500 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                    <i className="ri-calendar-check-line mr-2"></i>Reservar Ahora
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Load More Button */}
        {visibleCount < filteredYachts.length && (
          <div className="text-center">
            <button
              onClick={loadMore}
              className="bg-gradient-to-r from-teal-500 to-emerald-600 text-white px-8 py-4 rounded-full font-semibold hover:from-teal-400 hover:to-emerald-500 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-add-line mr-2"></i>Cargar Más Yates
            </button>
          </div>
        )}
      </div>
    </section>
  );
}